import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { handbooksResourceType } from "./handbooksResourceConsts";

export const handbookItemIdentifierStruct = createIdentifierStruct(
  handbooksResourceType
);
